import { Injectable } from "@angular/core";
import { saveAs } from "file-saver";

@Injectable({ providedIn: 'root' })

export class FileService {
    fileMimeTypes = [
        { extension: "csv", value: "text/csv;charset=utf-8" },
        { extension: "doc", value: "application/msword;charset=utf-8" },
        { extension: "docx", value: "application/vnd.openxmlformats-officedocument.wordprocessingml.document;charset=utf-8" },
        { extension: "gif", value: "image/gif;charset=utf-8" },
        { extension: "jpeg", value: "image/jpeg;charset=utf-8" },
        { extension: "jpg", value: "image/jpeg;charset=utf-8" },
        { extension: "png", value: "image/png;charset=utf-8" },
        { extension: "pdf", value: "application/pdf;charset=utf-8" },
        { extension: "ppt", value: "application/vnd.ms-powerpoint;charset=utf-8" },
        { extension: "rar", value: "application/x-rar-compressed;charset=utf-8" },
        { extension: "xls", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
        { extension: "xlsx", value: "vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=utf-8" },
        { extension: "zip", value: "application/zip;charset=utf-8" },
        { extension: "txt", value: "text/plain;charset=utf-8" }
    ];

    downloadFile(name: string, content: string, locationUrl?: string): void {
        const ext = name.substring(name.lastIndexOf('.') + 1).toLocaleLowerCase();
        const mimeTypes = this.fileMimeTypes.filter(el => el.extension === ext);

        if (mimeTypes.length && content) {
            const base64 = content;
            const mime = mimeTypes[0].value;
            const blob = this.dataURItoBlob(base64, mime);
            const file = new File([blob], name, { type: mime });
            saveAs(file, name)
        } else {
            window.open(locationUrl);
        }
    }

    dataURItoBlob(dataURI: string, mimeType: string): Blob {
        const kept = dataURI.split(",", 2);
        const byteString = atob(kept[1]);
        const arrayBuffer = new ArrayBuffer(byteString.length);
        const int8Array = new Uint8Array(arrayBuffer);
        for (let i = 0; i < byteString.length; i++) {
            int8Array[i] = byteString.charCodeAt(i);
        }
        const blob = new Blob([int8Array], { type: mimeType });
        return blob;
    }
}
